<template>
  <!-- <div class="pic_area">
    <div class="pic_area_input">
      <input @input="theInput" type="number" placeholder="不用加63 直接输入09或9开头号码" v-model="inputNumber" maxlength="11"
        autofocus="autofocus">
    </div>
    <br>
  </div> -->

  <!-- 新添加代码 start -->
  <div class="area-input flex-row">
    <div class="left flex-row">
      <img src="@/static/images/mobile.png" />
      <span>+63</span>
    </div>
    <div class="enter flex-1 flex-column">
      <input v-model="inputNumber" type="number" placeholder="请输入菲律宾手机号码"
      maxlength="11" autofocus="autofocus" @input="theInput" />
    </div>
  </div>
  <!-- 新添加代码 start -->
</template>

<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setTimeout(callback, ms)
    }
  })()

  export default {
    name: "inputArea",
    data() {
      return {
        inputNumber: "",
        inputNumber2: "",
        theCheck: '',
        theType: ''
      }
    },
    mounted() {
      var _vm = this;
      var usinfo = sessionStorage.getItem(name + 'usinfo');
      if (usinfo) {
        var u = JSON.parse(usinfo);
        if (u.Commonnumber) {
          _vm.inputNumber = u.Commonnumber;
          _vm.theInput();
        }
      }
    },
    methods: {
      theInput: function(e) {

        this.$emit("func", "NAN", "NAN", true);
        this.inputNumber = this.inputNumber.replace(/^\.+|[^\d.]/g, '').slice(0, 11);

        var Num = this.inputNumber;


        if (Num.length == 4) {


          var check = this.common.test(Num);
          switch (check) {
            case 1:
              this.theType = 1;

              break;
            case 2:
              this.theType = 2;

              break;
            case 3:
              this.theType = 3;

              break;
            case 4:
              this.theType = 4;

              break;

          }
          this.$emit("func", this.inputNumber, this.theType, false)

        }
        if (Num.length > 4) {
          delay(() => {
            var check = this.common.test(Num);
            //console.log(Num.length,check)
            switch (check) {
              case 1:
                this.theType = 1;

                break;
              case 2:
                this.theType = 2;

                break;
              case 3:
                this.theType = 3;

                break;
              case 4:
                this.theType = 4;

                break;

            }

            this.$emit("func", this.inputNumber, this.theType, false)

          }, 500)

        }



      }


    },
    created: function() {},

  }
</script>
<style lang="less" scoped>
  input::-webkit-input-placeholder {
    font-size: 14px;
    // color: #878787;
    color: rgba(86, 86, 86, .43);
  }

  .area-input {
    height: 49px;
    border-radius: 3px;
    background: rgba(218, 218, 218, 0.56);
    padding: 0 17px;
    text-align: left;
    margin-bottom: 12px;

    .left {

      img {
        width: 22px;
        height: auto;
        margin-right: 6px;
      }

      span {
        color: rgb(86, 86, 86);
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: 500;
        line-height: 22px;
      }

    }

    .enter {
      height: 100%;
      padding-left: 8px;
      input {
        width: 100%;
        height: 100%;
        border: none;
        box-sizing: border-box;
        outline: none;
        font-size: 14px;
      }
    }

  }

  /* .pic_area {
    height: 2.5rem;
    line-height: 2.5rem;

    border-bottom: 1px solid #959595;
    display: flex;
    position: relative;

  }

  .pic_area::before {
    content: "";
    position: absolute;
    top: -10px;
    left: -35px;
    width: 44px;
    height: 44px;
    background-image: url(../../static/images/logo.png);
    background-size: 100% 100%;
    background-position: center;
  }

  .pic_area_input {
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    align-items: center;

  }

  .pic_area_input input {
    width: 100%;
  }

  input {
    border: 0;
    padding: 0;
    outline: none;
    height: 30px;
    font-size: 1em;
    margin: 0 10px;
    text-align: center;
  }

  input::-webkit-input-placeholder {
    text-align: center;
    font-size: 1em;
  } */
</style>



// WEBPACK FOOTER //
// src/components/inputArea.vue